import { useNavigate } from "react-router-dom";

export const ModuleError = ({
  error,
  componentStack,
  resetError,
  moduleName,
}) => {
  const navigate = useNavigate();

  const handleReturnHome = () => {
    resetError();
    navigate("/");
  };

  const handleRetry = () => {
    resetError();
    window.location.reload();
  };

  return (
    <div className="flex min-h-[calc(100vh-65px-4rem)] items-center justify-center">
      <div className="mb-8 max-w-md rounded-lg bg-white p-8 shadow-lg">
        <div className="text-center">
          <div className="mb-4 text-6xl text-red-500">⚠️</div>
          <h1 className="mb-2 text-2xl font-bold text-gray-900">
            {moduleName
              ? `${moduleName.charAt(0).toUpperCase() + moduleName.slice(1)} Module Error`
              : "Module Error"}
          </h1>
          <p className="mb-6 text-gray-600">
            Something went wrong in {moduleName ? "the " + moduleName : "this"}{" "}
            module. You can try refreshing or return to the home page.
          </p>

          <div className="space-y-3">
            <button
              onClick={handleRetry}
              className="w-full rounded bg-black px-4 py-2 text-white transition-colors hover:bg-gray-800"
            >
              Try Again
            </button>
            <button
              onClick={handleReturnHome}
              className="w-full rounded bg-gray-200 px-4 py-2 text-gray-800 transition-colors hover:bg-gray-300"
            >
              Return Home
            </button>
          </div>

          {process.env.NODE_ENV === "development" && (
            <details className="mt-6 text-left">
              <summary className="cursor-pointer text-sm text-gray-500 hover:text-gray-700">
                Error Details
              </summary>
              <div className="mt-2 rounded bg-gray-100 p-3 text-xs">
                <div className="mb-2 font-mono text-red-600">
                  {error?.toString()}
                </div>
                <div className="font-mono text-gray-600">{componentStack}</div>
              </div>
            </details>
          )}
        </div>
      </div>
    </div>
  );
};

// Higher-order component factory for creating module-specific error boundaries
export const createModuleErrorBoundary = moduleName => {
  const ModuleErrorBoundary = ({ error, componentStack, resetError }) => (
    <ModuleError
      error={error}
      componentStack={componentStack}
      resetError={resetError}
      moduleName={moduleName}
    />
  );

  ModuleErrorBoundary.displayName = `ModuleErrorBoundary(${moduleName})`;

  return ModuleErrorBoundary;
};
